import React, { useEffect, useRef } from 'react';
import FadeIn from './FadeIn';
import { config } from '../config';

const SOCIABLEKIT_SCRIPT_ID = 'sociablekit-google-reviews-widget';
const SOCIABLEKIT_SCRIPT_SRC =
  'https://widgets.sociablekit.com/google-reviews/widget.js';
const SOCIABLEKIT_EMBED_ID = '25698646';
const GoogleReviews = () => {
const widgetRef = useRef(null);
const placeId = config.GOOGLE_PLACE_ID || 'ChIJhzyy1z9jUjoRlL5BiBN8IG4';
const writeReviewUrl = `https://search.google.com/local/writereview?placeid=${encodeURIComponent(
  placeId
)}`;

  useEffect(() => {
    const existingScript = document.getElementById(SOCIABLEKIT_SCRIPT_ID);
    if (existingScript && existingScript.parentNode) {
      existingScript.parentNode.removeChild(existingScript);
    }
    if (widgetRef.current) {
      widgetRef.current.innerHTML = '';
      widgetRef.current.removeAttribute('data-sk-initialized');
      widgetRef.current.removeAttribute('data-ui');
    }
    const script = document.createElement('script');
    script.id = SOCIABLEKIT_SCRIPT_ID;
    script.src = SOCIABLEKIT_SCRIPT_SRC;
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  return (
    <section className="google-reviews-section pt-12 pb-4 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <FadeIn delay={0.2} direction="down" fullWidth>
          <div className="text-center mb-6">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-textPrimary mb-4">
              What Our <span className="text-gradient">Students Say</span>
            </h2>
            <p className="text-lg text-textSecondary max-w-3xl mx-auto">
              Verified Google reviews for our academy
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} direction="up" fullWidth>
          <div className="google-reviews-widget-shell rounded-[20px] border border-gray-200 bg-white shadow-xl shadow-black/10 overflow-hidden p-6">

            {/* Header */}
            <div className="flex flex-col md:flex-row items-center justify-between gap-6 mb-8">

              <div className="flex items-center gap-4">
                <h3 className="text-2xl md:text-3xl font-bold text-gray-900">
                  Google Rating
                </h3>

                <span className="text-5xl font-bold text-primary">
                  5.0
                </span>

                <div className="flex text-yellow-400 text-3xl">
                  ★★★★★
                </div>
              </div>

              <a
                href={writeReviewUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary text-white font-semibold px-6 py-3 rounded-lg transition"
              >
                Write a Review
              </a>

            </div>

            {/* SociableKit Widget */}
            <div
              ref={widgetRef}
              className="sk-ww-google-reviews"
              data-embed-id={SOCIABLEKIT_EMBED_ID}
            />

          </div>
        </FadeIn>
      </div>
    </section>
  );
};

export default GoogleReviews;
